/**
 * Module dependencies.
 */

import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import eyeOnSvg from 'src/assets/24/eye-empty.svg';
import eyeOffSvg from 'src/assets/24/eye-off.svg';

import { InputField, InputFieldProps } from './field';

/**
 * `Props` type.
 */

type Props<T extends FieldValues> = Omit<InputFieldProps<T>, 'icon' | 'onIconClick' | 'type'>;

/**
 * Export `PasswordField` component.
 */

export function PasswordField<T extends FieldValues>(props: Props<T>) {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <InputField
      {...props}
      icon={showPassword ? eyeOnSvg : eyeOffSvg}
      onIconClick={() => setShowPassword(!showPassword)}
      type={showPassword ? 'text' : 'password'}
    />
  );
}
